import React, { useEffect, useState } from "react";
import Axios from "../../state/utils/api-caller";
import { Spin } from "../loading";
import { Config, configContext } from "./context";

const { Provider } = configContext;

interface ConfigProviderProps {
  children: any;
}

export function ConfigProvider(props: ConfigProviderProps) {
  const { children } = props;
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [config, setConfig] = useState<Config>({
    arcgisURL: "",
    baseURL: "",
    oauth: { clientId: "", redirectURL: "", server: "" },
  });

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((config) => {
        console.log((config as Config).baseURL);
        Axios.defaults.baseURL = (config as Config).baseURL;
        setConfig(config as Config);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoaded(true));
  }, []);

  return (
    <Provider value={config}>
      {loaded ? error ? <div>{error}</div> : children : <Spin />}
    </Provider>
  );
}
